export default "__VITE_ASSET__CzQMS6Ep__"